<template>
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" :width="width" :height="height"><g stroke-linecap="square" stroke-linejoin="miter" :stroke-width="strokewidth" :fill="_secondaryfill" :stroke="_secondaryfill"><line fill="none" stroke-miterlimit="10" x1="9" y1="9" x2="13" y2="9" stroke-linecap="butt" /> <line fill="none" stroke-miterlimit="10" x1="9" y1="14" x2="13" y2="14" stroke-linecap="butt" /> <line fill="none" stroke-miterlimit="10" x1="19" y1="9" x2="23" y2="9" stroke-linecap="butt" /> <line fill="none" stroke-miterlimit="10" x1="19" y1="14" x2="23" y2="14" stroke-linecap="butt" /> <path fill="none" stroke-miterlimit="10" d="M16,21 L16,21c-3.866,0-7-3.134-7-7V8c0-3.866,3.134-7,7-7h0c3.866,0,7,3.134,7,7v6C23,17.866,19.866,21,16,21z" /> <line fill="none" stroke-miterlimit="10" x1="8" y1="31" x2="24" y2="31" :stroke="fill" /> <line fill="none" stroke-miterlimit="10" x1="16" y1="25" x2="16" y2="31" :stroke="fill" /> <path fill="none" stroke-miterlimit="10" d="M27,14 c0,6.075-4.925,11-11,11h0C9.925,25,5,20.075,5,14" :stroke="fill" /></g></svg>
</template>

<script>
	export default {
		props: {
			width: {
				type: [
					Number,
					String
				],
				default: '100%'
			},
			height: {
				type: [
					Number,
					String
				],
				default: '100%'
			},
			strokewidth: {
				type: [
					Number,
					String
				],
				default: 1
			},
			fill: {
				type: String,
				default: 'currentColor'
			},
			secondaryfill: {
				type: String
			}
		},
		computed: {
			_secondaryfill() {
				return this.secondaryfill || this.fill;
			}
		}
	};
</script>